function t(e, ...n) {
  return n.reduce((o, r) => r(o), e);
}
export {
  t as B
};
